"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupCompanyLinkBlock = void 0;
const react_1 = __importDefault(require("react"));
const GroupCompanyLinkBlock = (props) => {
    var _a, _b;
    const createLink = (companyLink) => {
        var _a, _b;
        const url = new URL(companyLink.href);
        let offDomain = true;
        try {
            if (window.location.protocol !== url.protocol && window.location.host === url.host)
                url.protocol = window.location.protocol;
            offDomain = window.location.host !== url.host;
        }
        catch (e) {
            // Ignored on purpose
        }
        let icon = '';
        switch (props.data.company.value) {
            case 'if':
                icon = 'icon-if-grey';
                break;
            case 'hastings':
                icon = 'icon-hastings-big';
                break;
            case 'topdanmark':
                icon = 'icon-topdanmark-big';
                break;
            case 'mandatum':
                icon = 'icon-mandatum-big';
                break;
        }
        const title = companyLink.title ? companyLink.title : '';
        const linkProps = {
            title: companyLink.title,
            target: companyLink.target,
            className: `${title.toLowerCase()} col-12 col-sm d-flex justify-content-center align-items-center`,
            href: companyLink.href,
            key: `groups.${title + icon}`,
            rel: offDomain ? 'noreferrer' : ''
        };
        return react_1.default.createElement("a", Object.assign({}, linkProps, { className: linkProps.className }, (((_a = props.data.blockLanguage) === null || _a === void 0 ? void 0 : _a.value) !== '' ? { lang: (_b = props.data.blockLanguage) === null || _b === void 0 ? void 0 : _b.value } : null)),
            react_1.default.createElement("span", { className: 'visually-hidden' }, companyLink.title),
            react_1.default.createElement("span", { className: icon }));
    };
    const link = [];
    (_b = (_a = props.data.companyLink) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.forEach(function (x) {
        link.push(createLink(x));
    });
    return react_1.default.createElement(react_1.default.Fragment, null, link);
};
exports.GroupCompanyLinkBlock = GroupCompanyLinkBlock;
exports.default = exports.GroupCompanyLinkBlock;
